<ng-container
  *ngLet="{
    open: isOpen | async
  } as vm"
>
  <button
    rivButton
    #anchor
    [locked]="locked"
    [disabled]="disabled"
    [rivLockedTooltip]="
      hideTooltip ? undefined : 'You don\'t have permission to view this item'
    "
    [size]="size"
    [variant]="buttonType"
    [loading]="loading"
    [active]="active"
    [full]="full"
    [icon]="icon"
    [iconPosition]="iconPosition"
    (click)="
      !vm.disabled && isOpen.next(!vm.open);
      submitFormOnClick && click.emit($event)
    "
  >
    <ng-content select="[button-content]"></ng-content>
  </button>
  <ng-container *ngIf="vm.open && !disabled">
    <deprecated-callout
      *deprecated-callout
      [anchor]="anchorRef.nativeElement"
      fallbackDirection="cw"
      [allowedPositions]="
        topAndBottomPositionsOnly ? topAndBottomPositions : allowedPositions
      "
      [preferredPosition]="preferredPosition"
      (close)="isOpen.next(false)"
      [scrollable]="scrollableCallout"
    >
      <div [style.min-width.px]="anchorWidth">
        <ng-content></ng-content>
      </div>
    </deprecated-callout>
  </ng-container>
</ng-container>
